"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  createDefaultVariableTypes: true,
  BalanceVariable: true,
  LiteralVariable: true,
  TemplateVariable: true,
  CallVariable: true,
  NftVariable: true,
  ConditionVariable: true,
  OwnedNftsVariable: true,
  ImageVariable: true,
  RepeatVariable: true,
  RootParameterVariable: true,
  PointerVariable: true,
  CollectionItemVariable: true,
  CollectionVariable: true,
  ParameterVariable: true
};
Object.defineProperty(exports, "BalanceVariable", {
  enumerable: true,
  get: function () {
    return _BalanceVariable.BalanceVariable;
  }
});
Object.defineProperty(exports, "CallVariable", {
  enumerable: true,
  get: function () {
    return _CallVariable.CallVariable;
  }
});
Object.defineProperty(exports, "CollectionItemVariable", {
  enumerable: true,
  get: function () {
    return _CollectionItemVariable.CollectionItemVariable;
  }
});
Object.defineProperty(exports, "CollectionVariable", {
  enumerable: true,
  get: function () {
    return _CollectionVariable.CollectionVariable;
  }
});
Object.defineProperty(exports, "ConditionVariable", {
  enumerable: true,
  get: function () {
    return _ConditionVariable.ConditionVariable;
  }
});
Object.defineProperty(exports, "ImageVariable", {
  enumerable: true,
  get: function () {
    return _ImageVariable.ImageVariable;
  }
});
Object.defineProperty(exports, "LiteralVariable", {
  enumerable: true,
  get: function () {
    return _LiteralVariable.LiteralVariable;
  }
});
Object.defineProperty(exports, "NftVariable", {
  enumerable: true,
  get: function () {
    return _NftVariable.NftVariable;
  }
});
Object.defineProperty(exports, "OwnedNftsVariable", {
  enumerable: true,
  get: function () {
    return _OwnedNftsVariable.OwnedNftsVariable;
  }
});
Object.defineProperty(exports, "ParameterVariable", {
  enumerable: true,
  get: function () {
    return _ParameterVariable.ParameterVariable;
  }
});
Object.defineProperty(exports, "PointerVariable", {
  enumerable: true,
  get: function () {
    return _PointerVariable.PointerVariable;
  }
});
Object.defineProperty(exports, "RepeatVariable", {
  enumerable: true,
  get: function () {
    return _RepeatVariable.RepeatVariable;
  }
});
Object.defineProperty(exports, "RootParameterVariable", {
  enumerable: true,
  get: function () {
    return _RootParameterVariable.RootParameterVariable;
  }
});
Object.defineProperty(exports, "TemplateVariable", {
  enumerable: true,
  get: function () {
    return _TemplateVariable.TemplateVariable;
  }
});
exports.createDefaultVariableTypes = createDefaultVariableTypes;
var _ContractVariable = require("./type/ContractVariable");
Object.keys(_ContractVariable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ContractVariable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContractVariable[key];
    }
  });
});
var _BalanceVariable = require("./type/BalanceVariable");
var _VariableTypeRegistry = require("./VariableTypeRegistry");
var _LiteralVariable = require("./type/LiteralVariable");
var _TemplateVariable = require("./type/TemplateVariable");
var _CallVariable = require("./type/CallVariable");
var _NftVariable = require("./type/NftVariable");
var _ConditionVariable = require("./type/ConditionVariable");
var _OwnedNftsVariable = require("./type/OwnedNftsVariable");
var _ImageVariable = require("./type/ImageVariable");
var _RepeatVariable = require("./type/RepeatVariable");
var _DumbappArgumentsVariable = require("./type/DumbappArgumentsVariable");
Object.keys(_DumbappArgumentsVariable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DumbappArgumentsVariable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _DumbappArgumentsVariable[key];
    }
  });
});
var _RootParameterVariable = require("./type/RootParameterVariable");
var _PointerVariable = require("./type/PointerVariable");
var _CollectionItemVariable = require("./type/CollectionItemVariable");
var _CollectionVariable = require("./type/CollectionVariable");
var _ParameterVariable = require("./type/ParameterVariable");
Object.keys(_ParameterVariable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ParameterVariable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ParameterVariable[key];
    }
  });
});
var _WriteableVariable = require("./type/WriteableVariable");
Object.keys(_WriteableVariable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WriteableVariable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WriteableVariable[key];
    }
  });
});
var _WalletVariable = require("./type/WalletVariable");
Object.keys(_WalletVariable).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _WalletVariable[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _WalletVariable[key];
    }
  });
});
function createDefaultVariableTypes(api) {
  return new _VariableTypeRegistry.VariableTypeRegistry().register(new _BalanceVariable.BalanceVariable()).register(new _CallVariable.CallVariable()).register(new _ConditionVariable.ConditionVariable()).register(new _ContractVariable.ContractVariable(api)).register(new _ImageVariable.ImageVariable()).register(new _LiteralVariable.LiteralVariable()).register(new _NftVariable.NftVariable()).register(new _OwnedNftsVariable.OwnedNftsVariable()).register(new _RepeatVariable.RepeatVariable()).register(new _RootParameterVariable.RootParameterVariable()).register(new _TemplateVariable.TemplateVariable()).register(new _PointerVariable.PointerVariable()).register(new _ParameterVariable.ParameterVariable()).register(_CollectionVariable.CollectionVariable).register(_CollectionItemVariable.CollectionItemVariable).register(new _DumbappArgumentsVariable.DumbappArgumentsVariable());
}
//# sourceMappingURL=types.js.map